import styled from "styled-components";
import { Progress } from 'antd';

const PodProgress = styled(Progress)``;

export default PodProgress;
